// removed by extract-text-webpack-plugin
module.exports = {"saveButton":"XdX9OY-wFwUAorgV1QsB9","message":"_21Amo2dK9ErKmHw6MWOI7k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/SelectModelForm.css
// module id = 1044
// module chunks = 0